import React, { useState } from 'react';
import { migrateSubscribersToTokenStructure } from '../../utils/migrations';
import Button from '../common/Button';
import { debug } from '../../utils/debug';

const MigrationTools: React.FC = () => {
  const [migrationStatus, setMigrationStatus] = useState<{
    running: boolean;
    result: {
      success?: boolean;
      migrated?: number;
      errors?: number;
      message?: string;
    } | null;
  }>({
    running: false,
    result: null
  });

  const handleMigrateSubscribers = async () => {
    if (migrationStatus.running) return;
    
    if (!window.confirm('Are you sure you want to migrate subscribers to the new token structure? This operation cannot be undone.')) {
      return;
    }
    
    try {
      setMigrationStatus({
        running: true,
        result: null
      });
      
      debug.log('Starting subscriber migration');
      const result = await migrateSubscribersToTokenStructure();
      debug.log('Migration completed:', result);
      
      setMigrationStatus({
        running: false,
        result
      });
    } catch (error) {
      debug.error('Migration error:', error);
      
      setMigrationStatus({
        running: false,
        result: {
          success: false,
          message: `Migration failed: ${error instanceof Error ? error.message : String(error)}`
        }
      });
    }
  };

  return (
    <div className="bg-white shadow rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4">Migration Tools</h2>
      
      <div className="mb-6">
        <h3 className="text-lg font-medium mb-2">Subscriber Token Migration</h3>
        <p className="text-gray-600 mb-4">
          This tool migrates existing subscribers to the new token-based structure.
          It creates a token record for each subscriber and links them together.
        </p>
        
        <div className="flex items-center space-x-4">
          <Button
            onClick={handleMigrateSubscribers}
            disabled={migrationStatus.running}
            variant="primary"
          >
            {migrationStatus.running ? 'Migrating...' : 'Migrate Subscribers'}
          </Button>
          
          {migrationStatus.result && (
            <div className={`text-sm ${migrationStatus.result.success ? 'text-green-600' : 'text-red-600'}`}>
              {migrationStatus.result.message}
            </div>
          )}
        </div>
        
        {migrationStatus.result && migrationStatus.result.success && (
          <div className="mt-4 text-sm">
            <p>Migrated: {migrationStatus.result.migrated}</p>
            <p>Errors: {migrationStatus.result.errors}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default MigrationTools;